<template>
  <div class="o-p-content-dir">
  <div class="operation-pane-dir">
    <div class="o-p-middle-first">
         <div class="move-key"></div>
        <div class="move-text map-text-shadow">
        <div class="move-speed">
          <div  class="m-s-txt">
            <div class="m-s-txt-num">{{ formattedSpeed }}</div>
            <div class="unit-suffix">m/s</div>
          </div>
        </div>
      </div>
         <div class="move-key"></div>
    </div>
    <div class="o-p-middle-second">
        <!-- 左侧：俯仰角显示 -->
      <div class="dir-left">
        <div class="d-l-num map-text-shadow">{{ formattedPitch }}°</div>
        <div class="d-l-axle">
          <div class="axle"></div>
          <div class="marker" style="top: 37.5%;"></div>
          <div class="marker m-center"></div>
          <div class="marker" style="top: 68.75%;"></div>
          <div class="marker" style="top: 87.5%;"></div>
          <div class="gimbals" :style="gimbalStyle"></div>
        </div>
      </div>
      <div class="dir-center">
        <div class="air-img">
          <i class="iconfont icon-direction direction-icon"></i>
        </div>
        <div class="d-c-img">
          <img :src="compassImg" :style="compassStyle" alt="compass" />
        </div>
        <div class="limit-marker limit1"></div>
        <div class="limit-marker limit2"></div>
        <div class="dir-gimbal">
          <div class="d-g-icon"></div>
        </div>
        <div class="angle-number">
          <div class="a-n-val map-text-shadow">{{ formattedDroneHeading }}°</div>
          <div class="a-n-limit"></div>
        </div>
      </div>
          <div class="dir-right">
        <div class="d-r-axle">
          <div class="axle"></div>
          <div class="marker-center"></div>
        </div>
        <div class="d-r-text map-text-shadow">
          <template>
            {{ formattedHeightASL }}m
          </template>
        </div>
      </div>
    </div>
    <div class="o-p-middle-third">
        <div class="up-key move-key"></div>
         <!-- 高度显示区域 -->
      <div class="updown-text">
        <!-- ALT 高度 -->
        <div class="main-num">
          <div class="m-n-val map-text-shadow">
            <span>{{ formattedHeightALT }}</span>

          </div>
          <div class="m-n-unit">
            <div class="unit1 map-text-shadow">ALT</div>
            <div class="unit1 map-text-shadow">m</div>
          </div>
        </div>

        <!-- ASL 高度 -->
        <div class="other-num">
          <div class="o-n-val map-text-shadow">
            <span>{{ formattedHeightAGL }}</span>
          </div>
          <div class="o-n-unit map-text-shadow">ASL</div>
        </div>
      </div>
      <div class="down-key move-key"></div>
    </div>
    </div>
    </div>
</template>

<script setup>
import { ref, computed, onMounted, onUnmounted, defineProps } from 'vue'
import compassImg from '/@/assets/icons/compass_edit.svg' // 需要根据实际路径调整

// Props定义
const props = defineProps({
  curSpeed: {
    type: [Number, String],
    default: 0
  },
  curPitch: {
    type: [Number, String],
    default: 0
  },
  curDroneHeading: {
    type: [Number, String],
    default: 0
  },
  curGimbalHeading: {
    type: [Number, String],
    default: 0
  },
  curHeightASL: {
    type: [Number, String],
    default: 0
  },
  curHeightALT: {
    type: [Number, String],
    default: 0
  },
  curHeightAGL: {
    type: [Number, String],
    default: 0
  }
})

// 格式化显示，确保显示两位小数
const formatNumber = (value) => {
  const num = parseFloat(value)
  return isNaN(num) ? '0.00' : num.toFixed(2)
}
const gimbalStyle = computed(() => {
  const top = (120 - props.curPitch) / 240 * 100
  return `top: ${top}%`
})
const compassStyle = computed(() => {
  return `transform: rotate(${props.curDroneHeading}deg);`
})
// 计算属性格式化
const formattedSpeed = computed(() => formatNumber(props.curSpeed))
const formattedPitch = computed(() => formatNumber(props.curPitch))
const formattedDroneHeading = computed(() => formatNumber(props.curDroneHeading))
const formattedHeightASL = computed(() => formatNumber(props.curHeightASL))
const formattedHeightALT = computed(() => formatNumber(props.curHeightALT))
const formattedHeightAGL = computed(() => formatNumber(props.curHeightAGL))

// 监听数据更新（如果需要实时更新）
const updateInterval = ref(null)

onMounted(() => {
  // 如果需要定期更新，可以在这里设置定时器
  // updateInterval.value = setInterval(() => {
  //   // 更新逻辑
  // }, 100)
})

onUnmounted(() => {
  if (updateInterval.value) {
    clearInterval(updateInterval.value)
  }
})
</script>

<style lang="scss" scoped>
.map-text-shadow {
  text-shadow: 0 0 4px rgb(var(--colorBgLayout-rgb) / .5), -1px -1px 0 rgb(var(--colorBgLayout-rgb) / .5), 1px -1px 0 rgb(var(--colorBgLayout-rgb) / .5), -1px 1px 0 rgb(var(--colorBgLayout-rgb) / .5), 1px 1px 0 rgb(var(--colorBgLayout-rgb) / .5);
}
.o-p-content-dir {
  position: fixed;
  left: 509px;
  pointer-events: auto;
  margin: 0 auto;
  display: flex;
  font-weight: 400;
  font-size: 16px;
  color: var(--colorText);
  z-index: 301;
  bottom:110px;
.operation-pane-dir {
  display: flex;
  flex-direction: row;
}

.move-key {
  width: 100%;
  height: 56px;
  border-radius: 4px;
  display: flex;
  padding: 4px;
//   background: var(--colorBgElevated);

  &.hide {
    background: transparent;
  }

  .m-k-li {
    margin-left: 4px;

    &:first-child {
      margin: 0
    }

    .icon {
      text-align: center;
      line-height: 20px
    }

    .btn {
      width: 32px;
      height: 28px;
      text-align: center;
      border-radius: 4px;
      font-size: 16px;
      line-height: 28px;
      -webkit-user-select: none;
      user-select: none;
      cursor: pointer;
      background: var(--colorFillTertiary);

      &:hover {
        background-color: var(--colorPrimaryHover)
      }

    }

    .selectBtn {
      background-color: var(--colorPrimary)
    }
  }
}

.o-p-middle-first {
  margin-left: 24px;
  height: 172px;
  width: 112px;

  .move-text {
    width: 100%;
    height: 60px;
    color: #00ee8b;
    font-weight: 600;
    font-size: 16px;

    .move-speed {
      display: flex;
      align-items: center;
      justify-content: flex-end;
      width: 100%;
      height: 60px;

      .m-s-txt {
        display: flex;
        justify-content: flex-end;
        align-items: flex-end;
        width: 100%;
        height: 28px;

        .m-s-txt-num {
          font-weight: 600;
          font-size: 32px;
          height: 100%;
          line-height: 100%;
          outline: 1px;
        }

        .unit-suffix {
          margin-left: 6px;
          margin-bottom: -6px;
        }
      }
    }

    .move-speed-com {
      display: flex;
      line-height: 60px;

      .m-s-c-txt,
      .m-s-c-input {
        width: 50%;
      }

      .m-s-c-input {
        .ant-input {
          height: 28px;
          border: none;
          color: var(--colorTextBase);
          background-color: var(--colorBgElevated);

          &.input-disabled {
            color: var(--colorTextSecondary);
          }
        }
      }
    }
  }
}

.map-text-shadow {
  text-shadow: 0 0 4px rgb(var(--colorBgLayout-rgb) / .5), -1px -1px 0 rgb(var(--colorBgLayout-rgb) / .5), 1px -1px 0 rgb(var(--colorBgLayout-rgb) / .5), -1px 1px 0 rgb(var(--colorBgLayout-rgb) / .5), 1px 1px 0 rgb(var(--colorBgLayout-rgb) / .5);
}

.o-p-middle-second {
  width: 244px;
  height: 100%;
  display: flex;
  position: relative;
  margin-top: 26px;

  .dir-left {
    width: 52px;
    height: 100%;
    padding: 10px 0 0 4px;
    position: relative;

    .d-l-num {
      color: #00ee8b;
      font-size: 16px;
      line-height: 24px;
      font-weight: 600;
      text-align: right;
    }

    .d-l-axle {
      padding-left: 7px;
      padding-right: 5px;
      position: relative;
      height: 80px;

      .axle {
        position: absolute;
        right: 14px;
        width: 7px;
        height: 80px;
        background: var(--colorTextTertiary);
        color: var(--colorTextQuaternary);
        box-shadow: 0 2px 4px rgb(var(--colorBgLayout-rgb) / 0.2);
      }

      .marker {
        position: absolute;
        right: 14px;
        transform: translateY(-50%);
        width: 7px;
        height: 2px;
        background-color: var(--colorTextBase);
        box-shadow: 0 0 0 0.4px rgb(var(--colorBgLayout-rgb) / 0.6);

        &.m-center {
          top: 50%;
          right: 9px;
          width: 12px;
        }
      }

      .gimbals {
        position: absolute;
        transform: rotate(90deg) translate(-50%, -50%);
        left: 9px;
        display: block;
        width: 8px;
        height: 8px;
        background-color: var(--colorPrimaryHover);
        transition: all 0.2s ease-in-out;

        &::after {
          content: "";
          display: block;
          width: 0;
          height: 0;
          border-left: 4px solid transparent;
          border-right: 4px solid transparent;
          border-bottom: 4px solid var(--colorPrimaryHover);
          position: absolute;
          bottom: 100%;
        }
      }
    }
  }

  .dir-center {
    width: 140px;
    height: 140px;
    background: radial-gradient(circle,
        transparent 46.5%,
        rgb(var(--colorBgLayout-rgb) / 0.5) 0,
        rgb(var(--colorBgLayout-rgb) / 0.5) 70%,
        transparent 0);
    position: relative;

    .air-img {
      position: absolute;
      left: 50px;
      top: 37px;

      .direction-icon {
        font-size: 40px;
        color: #4EA3DC;
      }
    }

    .d-c-img {
      width: 100%;
      height: 100%;
      position: absolute;
      left: 0;
      right: 0;

      img {
        width: 100%;
        height: 100%;
      }

      &::after {
        content: "";
        position: absolute;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        border-radius: 50%;
        border: 2px solid var(--colorPrimary);
        box-shadow: 0 0 5px 0 var(--colorPrimary);
      }
    }

    .limit-marker {
      transform-origin: center 75px;
      width: 2px;
      height: 26px;
      left: calc(50% - 1px);
      background-color: var(--colorError);
      color: var(--colorError);
      padding: 1px;
      position: absolute;
      top: -5px;

      &.limit1 {
        transform: rotate(-90deg);
      }

      &.limit2 {
        transform: rotate(90deg);
      }

      &::before {
        content: "";
        display: block;
        background-color: var(--colorError);
      }
    }

    .dir-gimbal {
      position: absolute;
      left: 63px;
      top: 8px;
      width: 100%;
      height: 100%;

      .d-g-icon {
        margin: 0.5px 1px 1px;
        display: block;
        width: 12px;
        height: 12px;
        background-color: var(--colorPrimaryHover);
        position: relative;

        &::before {
          content: "";
          display: block;
          width: 0;
          height: 0;
          border-left: 6px solid transparent;
          border-right: 6px solid transparent;
          border-bottom: 6px solid var(--colorPrimaryHover);
          position: absolute;
          bottom: 100%;
        }
      }
    }

    .angle-number {
      font-size: 16px;
      line-height: 24px;
      font-weight: 600;
      color: #00ee8b;
      display: flex;
      position: absolute;
      top: -9px;
      left: calc(50% - 1.5px);

      .a-n-val {
        position: absolute;
        top: -25px;
        width: 40px;
        text-align: center;
        left: -20px;
      }

      .a-n-limit {
        display: block;
        width: 3px;
        height: 10px;
        background: #00ee8b;
        box-shadow: 0 0 4px rgb(var(--colorBgLayout-rgb) / 0.5),
          -1px -1px rgb(var(--colorBgLayout-rgb) / 0.5),
          1px -1px rgb(var(--colorBgLayout-rgb) / 0.5),
          -1px 1px rgb(var(--colorBgLayout-rgb) / 0.5),
          1px 1px rgb(var(--colorBgLayout-rgb) / 0.5);
      }
    }
  }

  .dir-right {
    width: 52px;
    height: 100%;
    padding: 34px 0 0 4px;
    position: relative;

    .d-r-axle {
      padding-left: 7px;
      padding-right: 5px;
      position: relative;
      height: 80px;

      .axle {
        position: absolute;
        width: 7px;
        height: 80px;
        background: var(--colorTextTertiary);
        color: var(--colorTextQuaternary);
        left: 14px;
        box-shadow: 0 2px 4px rgb(var(--colorBgLayout-rgb) / 0.2);
      }

      .marker-center {
        width: 12px;
        height: 2px;
        background-color: var(--colorTextBase);
        position: absolute;
        transform: translateY(-50%);
        box-shadow: 0 0 0 0.4px rgb(var(--colorBgLayout-rgb) / 0.6);
        left: 9px;
        top: 50%;
      }
    }

    .d-r-text {
      color: var(--colorTextBase);
      font-size: 12px;
      line-height: 20px;
      font-weight: 600;

      .ant-input {
        width: 40px;
        height: 16px;
        border: none;
        color: var(--colorTextBase);
        background-color: var(--colorBgElevated);
        padding: 4px;

        &.input-disabled {
          color: var(--colorTextSecondary);
        }
      }
    }
  }
}

.o-p-middle-third {
  height: 100%;

  .up-key,
  .down-key {
    width: 40px;
  }

  .updown-text {
    height: 60px;
    padding: 6px 0;

    .main-num {
      display: flex;
      height: 24px;
      max-width: 117px;
      font-weight: 600;
      font-size: 32px;
      color: #00ee8b;

      .m-n-val {
        height: 100%;
        font-size: 24px;
        line-height: 28px;

        .ant-input {
          height: 20px;
          border: none;
          color: var(--colorTextBase);
          background-color: var(--colorBgElevated);
          padding: 4px;

          &.input-disabled {
            color: var(--colorTextSecondary);
          }
        }
      }

      .m-n-unit {
        width: 27px;
        height: 24px;
        font-size: 14px;
        color: #00ee8b;
        line-height: 16px;
        margin-left: 4px;

        .unit1 {
          text-align: right;
          font-size: 12px;
        }
      }
    }

    .other-num {
      margin-top: 6px;
      font-weight: 600;
      color: var(--colorTextBase);
      line-height: 12px;
      display: flex;
      font-size: 12px;
      max-width: 117px;

      .o-n-val {
        width: calc(100% - 20px);
        height: 100%;
        text-align: right;

        .ant-input {
          width: 50px;
          height: 16px;
          border: none;
          color: var(--colorTextBase);
          background-color: var(--colorBgElevated);
          padding: 4px;

          &.input-disabled {
            color: var(--colorTextSecondary);
          }
        }
      }

      .o-n-unit {
        margin: 0 0 0 4px;
        width: 20px;
        height: 100%;
      }
    }
  }
}

}
</style>
